import { render, staticRenderFns } from "./RenameProfile.vue?vue&type=template&id=8896d2be"
import script from "./RenameProfile.vue?vue&type=script&lang=js"
export * from "./RenameProfile.vue?vue&type=script&lang=js"
import style0 from "./RenameProfile.vue?vue&type=style&index=0&id=8896d2be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports